import React from 'react'
import './Tempreture.css';

const Tempreture = () => {
  return (
    <div className='tempreture-main-container'>
      <div className='firewall-main-heading-container'>
        <p>Firewall</p>
      </div>
      <div className='tempreture-circle-main-couter'>
        <div className='tempreture-circle-inner-round'>
          <div className='tempreture-circle-inner-round-0'></div>
          <div className='tempreture-circle-inner-round-2'></div>
          <div className='tempreture-circle-inner-round-3'></div>
            <div className='tempreture-circle-data-circle'>
                <h3 className='tempreture-text'>99</h3>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Tempreture
